import { useSearch } from "@tanstack/react-router";
import { loginRoute } from "./routeTree";

/** Landing screen for unauthenticated users. We don't try to do OIDC
 * client-side — clicking the button redirects to the backend's
 * /api/auth/login?next=... which hands off to Google and sets the
 * session cookie on callback. */
export function LoginPage() {
  const search = useSearch({ from: loginRoute.id });
  const next = search.next ?? "/tabs/global";

  const handleLogin = () => {
    const qs = new URLSearchParams({ next }).toString();
    window.location.href = `/api/auth/login?${qs}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-8">
      <div className="relative w-full max-w-md">
        <div
          aria-hidden
          className="absolute inset-[-40px] -z-10 rounded-[40px] bg-[radial-gradient(55%_70%_at_30%_30%,rgba(167,139,250,0.32)_0%,transparent_65%),radial-gradient(55%_70%_at_70%_70%,rgba(236,72,153,0.24)_0%,transparent_65%)] blur-2xl"
        />
        <div className="rounded-[24px] border border-border-2 bg-white/[0.04] p-10 text-center shadow-lg backdrop-blur">
          <img
            src="/logo-altostratus.svg"
            alt="Altostratus"
            className="mx-auto h-10 w-auto"
          />
          <h1 className="mt-6 font-display text-3xl font-bold tracking-tight text-text-1">
            Leaderboard de IA
          </h1>
          <p className="mt-3 text-sm text-text-3">
            Acceso restringido a cuentas{" "}
            <span className="font-semibold text-text-2">@altostratus.es</span>.
          </p>

          <button
            type="button"
            onClick={handleLogin}
            className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-gradient-to-br from-brand-1 to-brand-3 px-6 py-3 text-sm font-semibold text-white shadow-[0_12px_32px_-12px_rgba(236,72,153,0.6)] transition-transform hover:scale-[1.02]"
          >
            Entrar con Google
          </button>

          <p className="mt-6 text-xs text-text-4">
            Al entrar aceptas que registremos tu sesión para validar el dominio.
          </p>
        </div>
      </div>
    </div>
  );
}
